import { GraphQLFormattedError } from 'graphql';
import _some from 'lodash/some';
import _get from 'lodash/get';

export type TechnicalPauseErrorPayload = {
  endAt: string;
};

type TechnicalPauseCallback = (payload: TechnicalPauseErrorPayload) => void;

const listeners = new Set<TechnicalPauseCallback>();

export function hasTechnicalPauseError(
  graphQLErrors: readonly GraphQLFormattedError[] | undefined,
): boolean {
  return _some(
    graphQLErrors,
    ({ extensions }) => extensions?.code === 'TECHNICAL_PAUSE_ERROR',
  );
}

export function handleTechnicalPauseError(
  graphQLErrors: readonly GraphQLFormattedError[] | undefined,
): void {
  if (!graphQLErrors) return;

  const pauseError = graphQLErrors.find(
    ({ extensions }) => extensions?.code === 'TECHNICAL_PAUSE_ERROR',
  );
  if (!pauseError) return;

  const endAt = _get(pauseError, 'extensions.details.endAt') as
    | string
    | undefined;
  if (!endAt) return;

  listeners.forEach((callback) => callback({ endAt }));
}

export function onTechnicalPauseDetected(
  callback: TechnicalPauseCallback,
): void {
  listeners.add(callback);
}

export function offTechnicalPauseDetected(
  callback: TechnicalPauseCallback,
): void {
  listeners.delete(callback);
}

// Exported for testing only
export function clearListeners(): void {
  listeners.clear();
}
